export default "__VITE_ASSET__71ead6f3__"